import { useState, useEffect } from "react";
import InvoiceGraph from "../../components/InvoiceComponents/invoiceGraph";
import InvoiceTable from "../../components/InvoiceComponents/InvoiceTable";
import VmCostGraph from "../../components/InvoiceComponents/VmCostGraph";
import VmCostTable from "../../components/InvoiceComponents/VmCostTable";
import { useVmCost } from "../../hooks/useVmCost";
import ReservationTable from "../../components/InvoiceComponents/ReservationTable";
import ServiceCostGraph from "../../components/InvoiceComponents/ServiceCostGraph";
import PeriodCost from "../../components/InvoiceComponents/PeriodCost";
import AIInvoiceAnalysisCard from "../../components/InvoiceComponents/AIInvoiceAnalysisCard";
import AICostAnalysisCard from "../../components/InvoiceComponents/AICostAnalysisCard";

const InvoicePage = () => {
  const [vmCostIndex, setVmCostIndex] = useState(0);
  const {
    vmCostHistory,
    months,
    loading,
    error,
    hasNext,
    hasPrevious,
    getVmCostHistory,
  } = useVmCost();

  useEffect(() => {
    getVmCostHistory(vmCostIndex);
  }, [vmCostIndex]);

  const handlePageChange = (newIndex) => {
    setVmCostIndex(newIndex);
  };

  const data = {
    vmCostHistory,
    months,
  };

  return (
    <div className="overflow-x-hidden">
      <InvoiceTable />
      <InvoiceGraph />
      <AIInvoiceAnalysisCard />
      <ReservationTable />
      <PeriodCost />
      <VmCostTable
        data={data}
        loading={loading}
        error={error}
        index={vmCostIndex}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        onPageChange={handlePageChange}
      />
      <VmCostGraph />
      <ServiceCostGraph />
      <AICostAnalysisCard />
    </div>
  );
};

export default InvoicePage;